import { render, staticRenderFns } from "./DashBoardUser.vue?vue&type=template&id=bfa955c4&scoped=true"
import script from "./DashBoardUser.vue?vue&type=script&lang=js"
export * from "./DashBoardUser.vue?vue&type=script&lang=js"
import style0 from "./DashBoardUser.vue?vue&type=style&index=0&id=bfa955c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa955c4",
  null
  
)

export default component.exports